/**
 * Copy text to the clipboard, returning whether it actually succeeded.
 *
 * Prefers the async Clipboard API, which is only available in secure contexts
 * (HTTPS / localhost). Falls back to a hidden <textarea> + execCommand for
 * plain-HTTP or older browsers so callers can give honest feedback instead of a
 * blind "Copied" that lies when the write silently no-ops.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Permission denied or non-secure context — fall through to the fallback.
  }
  return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
  if (typeof document === "undefined") return false;
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  ta.remove();
  return ok;
}
